var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.745,
    height: 20.5,
    viewBox: "0 0 28.745 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11268",
    "data-name": "Group 11268",
    transform: "translate(-1168.467 -3009.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8034",
    "data-name": "Path 8034",
    d: "M27.3,7.809A15.4,15.4,0,0,0,13.927,0,15.85,15.85,0,0,0,.249,7.757a2.321,2.321,0,0,0,0,2.367A15.865,15.865,0,0,0,10.38,17.493",
    transform: "translate(1169.075 3010)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_23",
    "data-name": "Subtraction 23",
    d: "M7,14A7,7,0,0,1,0,7.182a1.4,1.4,0,1,0,.29-2.19A7,7,0,0,1,11.948,2.05,7,7,0,0,1,7,14Z",
    transform: "translate(1176.203 3010)",
    fill: "#7d7d7d",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2202",
    "data-name": "Ellipse 2202",
    cx: 2.2,
    cy: 2.2,
    r: 2.2,
    transform: "translate(1180.601 3025.6)",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8035",
    "data-name": "Path 8035",
    d: "M53.116,19.393a2.321,2.321,0,0,1,0,2.367,15.865,15.865,0,0,1-10.131,7.369",
    transform: "translate(1143.239 2998.362)",
    fill: "none",
    stroke: "#7d7d7d",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.b089ae23c8fb493a6f75b547b3e5c851.svg";
export { ForwardRef as ReactComponent };